export default {"src":"/_next/static/media/walking.mono.ab51fb46.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};